import { Injectable } from '@angular/core';
// import { Address } from 'ngx-google-places-autocomplete/objects/address';
// import { Address } from '@angular-magic/ngx-gp-autocomplete';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BehaviorSubject } from 'rxjs';
import { AlertService } from '../alert-service.service';
import { NetworkService } from '../network/network.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  POSTAL_API = '/auth/open/address-autofill?pin=';
  translationFlag: BehaviorSubject<any> = new BehaviorSubject(false);

  constructor(
    private alert: AlertService,
    private networkService: NetworkService,
    private ngxUiLoader: NgxUiLoaderService
  ) {
  }

  // getFormattedAddress(address: Address) {
  //   address = JSON.parse(JSON.stringify(address));
  //   const formatted_address = address.formatted_address;
  //   const geo = [address.geometry.location.lng, address.geometry.location.lat];
  //   const country = address.address_components.find(x => x.types.includes('country'));
  //   const locality = address.address_components.find(x => x.types.includes('locality'));
  //   const postalCode = address.address_components.find(x => x.types.includes('postal_code'));
  //   const streetAddress = address.address_components.find(x => x.types.includes('street_address'));
  //   const administrativeAreaLevel1 = address.address_components.find(x => x.types.includes('administrative_area_level_1'));
  //   const administrativeAreaLevel2 = address.address_components.find(x => x.types.includes('administrative_area_level_2'));
  //   const administrativeAreaLevel3 = address.address_components.find(x => x.types.includes('administrative_area_level_3'));
  //   const administrativeAreaLevel4 = address.address_components.find(x => x.types.includes('administrative_area_level_4'));
  //   const administrativeAreaLevel5 = address.address_components.find(x => x.types.includes('administrative_area_level_5'));
  //   const sublocalityLevel1 = address.address_components.find(x => x.types.includes('sublocality_level_1'));
  //   const sublocalityLevel2 = address.address_components.find(x => x.types.includes('sublocality_level_2'));
  //   const sublocalityLevel3 = address.address_components.find(x => x.types.includes('sublocality_level_3'));
  //   const sublocalityLevel4 = address.address_components.find(x => x.types.includes('sublocality_level_4'));
  //   const sublocalityLevel5 = address.address_components.find(x => x.types.includes('sublocality_level_5'));

  //   return {
  //     geo,
  //     line1: formatted_address || '',
  //     country: country?.long_name || '',
  //     zipcode: postalCode?.long_name || '',
  //     formattedAddress: formatted_address || '',
  //     line2: sublocalityLevel3?.long_name || '',
  //     block: administrativeAreaLevel4?.long_name || '',
  //     state: administrativeAreaLevel1?.long_name || '',
  //     district: administrativeAreaLevel2?.long_name || ''
  //   };
  // }

  getAlias(type: string) {
    switch (type) {
      case 'ACTIVE':
        return 'active';

      case 'BLOCKED':
        return 'blocked';

      case 'ADMIN_APPROVAL_PENDING':
        return 'admin approval pending';

      case 'SALES_APPROVAL_PENDING':
        return 'sales approval pending';

      case 'ADMIN_REJECTED':
        return 'rejected by admin';

      case 'SALES_REJECTED':
        return 'rejected by sales representative';

      default:
        return 'NA';
    }
  }

  translate(payload: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.ngxUiLoader.start();
      this.translationFlag.next(true);

      this.networkService.translationHttpRequest('/translate', { source: 'en', payload }, 'POST', false)
        .then((response: any) => {
          this.ngxUiLoader.stop();
          resolve(response.data.translation);
        })
        .catch(err => {
          this.alert.showAlert('Translation failed', 'warning');
          this.ngxUiLoader.stop();
          resolve('NA');
        })
        .finally(() => this.translationFlag.next(false));
    });
  }

  getZipcode(code: string): Promise<{
    state: string,
    district: string,
    taluka: string[],
    alphacode: string,
    statecode: number,
    districtCode: number
  } | null> {
    return new Promise((resolve, reject) => {

      this.networkService.httpRequest(this.POSTAL_API + code, undefined, 'GET', true)
        .then((response: any) => {
          if (!response.status) {
            this.alert.showAlert(response.message);
            resolve(null);
          } else {
            resolve({
              ...response.data,
              alphacode: response.metaData.alphacode,
              statecode: response.metaData.statecode,
              districtCode: response.metaData.district,
            });
          }
        })
        .catch(err => {
          this.alert.showAlert(err.message);
          resolve(null);
        });
    });
  }

  buildQueryString(payload: any): string {
    const query = [];
    for (const p in payload) {
      if (payload.hasOwnProperty(p)) {
        query.push(encodeURIComponent(p) + '=' + encodeURIComponent(payload[p]));
      }
    }
    return query.join('&');
  }

  downloadCertificate(medoplusId: string, type: string, language: string) {
    return this.networkService.httpRequest('/download/admin/download/certificate', { medoplusId, type, language }, "POST", true);
  }

  checkInput(event: any, type?: string, limit?: number): any {
    switch (type) {
      case 'number':
        if (
          (event.keyCode >= 35 && event.keyCode <= 40) ||
          event.keyCode === 46 ||
          event.keyCode === 13 ||
          event.keyCode === 8 ||
          event.keyCode === 9 ||
          event.keyCode === 27 ||
          event.keyCode === 110 ||
          event.keyCode === 190
        ) {
          return true;
        } else if (event.target.value.length === limit) {
          return false;
        } else {
          return (
            (event.keyCode >= 48 && event.keyCode < 58) ||
            (event.keyCode >= 96 && event.keyCode < 106)
          );
        }
      case 'alphanumeric':
        return (
          (event.keyCode >= 65 && event.keyCode <= 90) ||
          (event.keyCode >= 96 && event.keyCode < 106) ||
          (event.keyCode >= 48 && event.keyCode < 58) ||
          event.keyCode === 8 ||
          event.keyCode === 9 ||
          event.keyCode === 13 ||
          (event.keyCode >= 35 && event.keyCode <= 40) ||
          event.keyCode === 46 ||
          event.keyCode === 27
        );
      case 'name':
        return (
          (event.keyCode >= 65 && event.keyCode <= 90) ||
          event.keyCode === 8 ||
          event.keyCode === 32 ||
          event.keyCode === 9 ||
          event.keyCode === 13 ||
          (event.keyCode >= 35 && event.keyCode <= 40) ||
          event.keyCode === 46 ||
          event.keyCode === 27
        );
      default:
        return false;
    }
  }

  /**
   * Function to perform a deep copy on an object
   * @param obj - The object to be deeply copied
   * @returns A new object that is a deep copy of the input object
   */
  createDeepCopy(obj: any): any {
    if (!obj) {
      return null;
    }
    return JSON.parse(JSON.stringify(obj));
  }

   dateStringToUnixMilliseconds = (dateString: string): number => {
    const unixMilliseconds = moment(dateString).valueOf();
    return unixMilliseconds;
  };
}
